import { DatetimeService } from '@/services/DatetimeService';

export interface IBaseSearch {
    query: string;
    address: string;
    latitude: number;
    longitude: number;
    cache?: boolean;
}

export interface ISearch extends IBaseSearch {
    arrivalDate?: Date;
    arrivalTime?: string;
    departureDate?: Date;
    departureTime?: string;
    oversizedVehicle?: boolean;
    type?: EnumReservationType;
    searchType?: EnumSearchType;
}

export interface ISearchSuggestion {
    arrivalDate: Date;
    arrivalTime: string;
    departureDate: Date;
    departureTime: string;
}

export enum EnumReservationType {
    HOURLY = 'hourly',
    MONTHLY = 'monthly',
}

export enum EnumSearchType {
    MAP = 'map',
    LIST = 'list',
}


export class Search implements ISearch {
    // Location
    public query: string = '';
    public address: string = '';
    public latitude: number = 0;
    public longitude: number = 0;

    // Parameters
    public arrivalDate: Date = new Date();
    public arrivalTime: string = '11:00';
    public departureDate: Date = new Date();
    public departureTime: string = '12:00';
    public oversizedVehicle: boolean = false;
    public type: EnumReservationType = EnumReservationType.HOURLY;


    // Search Type
    public searchType: EnumSearchType = EnumSearchType.MAP;

    constructor(model?: Partial<ISearch>) {
        Object.assign(this, model);

        if (!model || (!model.arrivalDate || !model.arrivalTime)) {
            const suggestion = DatetimeService.getSearchSuggestion();

            this.arrivalDate = suggestion.arrivalDate;
            this.arrivalTime = suggestion.arrivalTime;
            this.departureDate = suggestion.departureDate;
            this.departureTime = suggestion.departureTime;

        }
    }

    public update(model: Partial<ISearch>) {
        Object.assign(this, model);
    }

    public toString() {
        return JSON.stringify({
            query: this.query,
            latitude: this.latitude,
            longitude: this.longitude,
            arrivalDate: this.arrivalDate,
            arrivalTime: this.arrivalTime,
            departureDate: this.departureDate,
            departureTime: this.departureTime,
            oversizedVehicle: this.oversizedVehicle,
            type: this.type,
            searchType: this.searchType,
        });
    }

}
